module.exports = __webpack_public_path__ + "static/media/DSC00426.ca9dda82.jpg";